import React, { Component } from "react";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { createPortal } from 'react-dom';
import playout from '../../../assets/images/playout.svg';
import cannotplay from '../../../assets/images/cannotplay.svg';
import "../../../components/AccountActivation/intro.css";
import "./index.less";

class Video extends Component {
    constructor(props) {
        super(props);
        this.refVideo = React.createRef();
        // 视频配置
        this.videoJsOptions = {
            language: 'zh-CN',
            controls: true, //控制条
            preload: 'auto', //自动加载
            errorDisplay: false, //错误展示
            fluid: false, // 跟随外层容器变化大小，跟随的是外层宽度
            userActions: { hotkeys: true }, //是否支持热键
            onError: (err) => console.log(err),
        };
        this.state = {
            showPlayIcon: true,
            isFullScreen: false,
            showText: false,
            ended: false,
            autoPlay: false,
            showVideoDisable: false, // 是否显示视频无法播放
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.url !== this.props.url) {
            this.removeButtonTitle();
            // 删除节点
            this.deleteNode();
            this.createNode();
            if (!nextProps.url) {
                this.setState({ showVideoDisable: true, showText: false, showPlayIcon: false, ended: false });
            } else {
                this.setState({ autoPlay: nextProps.autoPlay, showVideoDisable: false, showText: false, showPlayIcon: !nextProps.autoPlay, ended: false });
            }
        }
    }

    componentDidMount() {
        this.createNode();
        this.handlePlayVideo();
    }

    componentDidUpdate() {
        const { ended, autoPlay } = this.state;
        if (autoPlay && !ended) {
            setTimeout(() => {
                this.handlePlayVideo();
            }, 300);
        }
    }

    deleteNode = () => {
        const { containerClassName } = this.props;
        const doc = document.getElementsByClassName(containerClassName)[0];
        doc.removeChild(this.node);
    }

    createNode = () => {
        const { containerClassName } = this.props;
        const doc = document.getElementsByClassName(containerClassName)[0];
        // 定义this.node 创建一个div节点
        this.node = document.createElement("div");
        // 当前的body下挂载一个div节点
        doc.appendChild(this.node);
    }

    // 播放结束监听事件
    endedDureation = (e) => {
        if (e.target.duration > 45) {
            this.setState({
                showText: true,
                showPlayIcon: false,
                ended: true,
            });
        }
        this.removeButtonTitle();
    }

    // 暂停 监听事件
    pauseDureation = (e) => {
        if (e.target.paused) {
            this.setState({ showPlayIcon: true });
        }
        this.removeButtonTitle();
    }
    // 点击播放 监听事件
    playDureation = () => {
        this.setState({
            showText: false,
            showPlayIcon: false,
            autoPlay: false,
        });
        this.removeButtonTitle();
    }
    // 全屏按钮事件
    fullscreenChange = () => {
        const { isFullScreen } = this.state;
        if (!isFullScreen) {
            // 提示按esc退出全屏
        }
        if (document.fullscreenElement) {
            this.setState({ isFullScreen: true });
        } else {
            this.setState({ isFullScreen: false });
        }
        this.removeButtonTitle();
    }
    // 音量变化
    volumeChange = () => {
        this.removeButtonTitle();
    }

    onVideoError = () => {
        this.setState({ showVideoDisable: true, showPlayIcon: false });
    }

    // 去掉button默认title提示
    removeButtonTitle = () => {
        setTimeout(() => {
            const playButton = document.querySelector('.novice-guide-video-box .vjs-play-control');
            const muteButton = document.querySelector('.novice-guide-video-box .vjs-mute-control');
            const fullscreenButton = document.querySelector('.novice-guide-video-box .vjs-fullscreen-control');
            playButton.removeAttribute('title');
            muteButton.removeAttribute('title');
            fullscreenButton.removeAttribute('title');
        }, 100);
    }

    handlePlayVideo = () => {
        const refVideo = this.refVideo.current;
        const that = this;
        videojs(refVideo, this.videoJsOptions, function onPlayerReady() {
            this.on('fullscreenchange', that.fullscreenChange);
            refVideo.addEventListener('ended', that.endedDureation);
            refVideo.addEventListener('pause', that.pauseDureation);
            refVideo.addEventListener('play', that.playDureation);
            refVideo.addEventListener('fullscreenchange', that.fullscreenChange);
            refVideo.addEventListener('volumechange', that.volumeChange);
            refVideo.addEventListener('error', that.onVideoError);
            refVideo.play();
        });
    }

    // 关闭video
    handleCloseVideo = () => {
        const refVideo = this.refVideo.current;
        refVideo.removeEventListener('ended', this.endedDureation);
        refVideo.removeEventListener('pause', this.pauseDureation);
        refVideo.removeEventListener('play', this.playDureation);
        refVideo.removeEventListener('fullscreenchange', this.fullscreenChange);
        refVideo.removeEventListener('volumechange', this.volumeChange);
        refVideo.removeEventListener('error', this.onVideoError);
        // 删除节点
        this.deleteNode();
        this.createNode();
        this.setState({ isFullScreen: false });
    }

    renderTipsInfo = () => {
        const { isFullScreen } = this.state;
        let { name, langJSON } = this.props;
        name = langJSON[name.split('_')[0]];
        if (isFullScreen) {
            return (
                <div className="full-screen-tips">
                    <img className="playout-img" src={playout} alt="" />
                    <p>
                        {`"${name}" ${langJSON['videoGuide-0021']}`} <a onClick={this.handlePlayVideo}>{langJSON['videoGuide-0022']}</a>
                    </p>
                    <i className="icon iconfont icon-quxiao" onClick={this.handleCloseVideo} />
                </div>
            );
        } else {
            return (
                <div className="not-full-screen-tips">
                    <img className="playout-img" src={playout} alt="" />
                    <p>
                        {`"${name}" ${langJSON['videoGuide-0021']}`} <a onClick={this.handlePlayVideo}>{langJSON['videoGuide-0022']}</a>
                    </p>
                </div>
            );
        }
    }

    renderVideoDisabled = () => {
        let { langJSON } = this.props;
        return (
            <div className="video-disabled">
                <img className="playout-img" src={cannotplay} alt="" />
                <p>{langJSON['videoGuide-0025']}</p>
            </div>
        );
    }

    render() {
        const { showText, showPlayIcon, showVideoDisable } = this.state;
        const { url } = this.props;
        if (this.node) {
            return createPortal(
                <div className='video-guide-video-box'>
                    <div data-vjs-player>
                        <video
                            ref={this.refVideo}
                            controlsList="nodownload"
                            className="video-js"
                            disablePictureInPicture
                            key={url}
                        >
                            <source src={url} type="video/mp4"></source>
                        </video>
                        {
                            showText && this.renderTipsInfo()
                        }
                        {
                            (showPlayIcon && !showVideoDisable) && <i
                                className='icon iconfont icon-kaishi'
                                onClick={this.handlePlayVideo}
                            />
                        }
                        {
                            showVideoDisable && this.renderVideoDisabled()
                        }
                    </div>
                </div>, this.node);
        } else {
            return (
                <div className='video-guide-video-box'>
                    <div data-vjs-player>
                        <video
                            ref={this.refVideo}
                            controlsList="nodownload"
                            className="video-js"
                            disablePictureInPicture
                            key={url}
                        >
                            <source src={url} type="video/mp4"></source>
                        </video>
                        {
                            showText && this.renderTipsInfo()
                        }
                        {
                            showPlayIcon && <i
                                className='icon iconfont icon-kaishi'
                                onClick={this.handlePlayVideo}
                            />
                        }
                    </div>
                </div>);
        }
    }
}

export default Video;